import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { resetPassword } from '../../../apirapper/user.ts';

const ResetpasswordTwo = () => {
  const route = all_routes;
  const location = useLocation();
  const formData = location.state;
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return `Password must be at least ${minLength} characters long.`;
    }
    if (!hasUpperCase) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!hasLowerCase) {
      return "Password must contain at least one lowercase letter.";
    }
    if (!hasNumber) {
      return "Password must contain at least one number.";
    }
    if (!hasSpecialChar) {
      return "Password must contain at least one special character.";
    }
    return "";
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newPasswordError = validatePassword(newPassword);
    if (newPasswordError) {
      setError(newPasswordError);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New Password and Confirm Password do not match.");
      return;
    }

    try {
      console.log('formData',formData);
      console.log('newPassword',newPassword);
      const apiResponse = await resetPassword(formData.code,newPassword);

      if (apiResponse == '200') {
        navigate(route.signin);
      } else {
        setError("Failed to reset password: "+apiResponse);
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                  <h3>Reset password?</h3>
                  <h4>
                    Enter New Password &amp; Confirm Password to get inside
                  </h4>
                </div>
                <div className="form-login">
                  <label>New Password</label>
                  <div className="pass-group">
                    <input type={showPassword ? "text" : "password"} className="pass-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                    <span
                      className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
                <div className="form-login">
                  <label>Confirm New Password</label>
                  <div className="pass-group">
                    <input type={showPassword1 ? "text" : "password"} className="pass-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                    <span
                      className={`fas toggle-password ${showPassword1 ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePasswordVisibility1}
                      style={{ cursor: 'pointer' }}
                    />
                    </div>
                </div>
                {error && <div className="error-message text-danger">{error}</div>}
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Change Password
                  </button>
                </div>
                <div className="signinform text-center">
                  <h4>
                    Return to{" "}
                    <Link to={route.signin} className="hover-a">
                      Sign In
                    </Link>
                  </h4>
                </div>
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 WizzTech. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetpasswordTwo;
